import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseInvoiceAdjustmentIssueDateEarlierThanAdjustedError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.purchase.validation.issue-date.earlier-than-adjusted');
    }
}
